import type * as CheckoutPay from '@dni-types/payment/checkoutpay'
import type * as TapPay from '@dni-types/payment/tappay'
import { type PaymentMethod, PaymentMethodType, PaymentServiceType } from '@hooks-api/types/dataModel/payment'
import { type Nullable } from '@hooks-api/types/nullable'
import { CheckoutPayCreditCardModule, ECPayCreditCardModule, getActivePaymentModuleB2B, TappayCreditCardModule } from '@payments'
import { type AppliedPaymentModule } from './utility-process-pay-module'
export interface CardValidation {
  tappay: TapPay.CardUpdate | null
  checkoutpay: CheckoutPay.FrameCardValidationChangedEvent | null
}
export type AppliedPaymentModuleConstructor = abstract new (...args: unknown[]) => TappayCreditCardModule | CheckoutPayCreditCardModule | ECPayCreditCardModule
type CreditCardPaymentModule = TappayCreditCardModule | CheckoutPayCreditCardModule
const paymentCreditCardMap: Partial<Record<PaymentServiceType, readonly AppliedPaymentModuleConstructor[]>> = {
  [PaymentServiceType.TAPPAY]: [TappayCreditCardModule],
  [PaymentServiceType.CHECKOUTPAY]: [CheckoutPayCreditCardModule],
  [PaymentServiceType.ECPAY]: [ECPayCreditCardModule],
}
export const getCurrentSelectedMethod = (selectedMethodId: number, creditCardMethods: PaymentMethod[]) => {
  return creditCardMethods.find(method => method.id === selectedMethodId)
}
export const getIsValidModule = (module: AppliedPaymentModule | null, currentSelectedMethod: PaymentMethod) => {
  if (!currentSelectedMethod.service_type) return false
  const Constructors = paymentCreditCardMap[currentSelectedMethod.service_type]
  if (!module || !Constructors) return false
  return Constructors.some(Constructor => module instanceof Constructor)
}

export const getModule = (selectedMethodId: number, creditCardMethods: PaymentMethod[]): CreditCardPaymentModule | null => {
  const currentSelectedMethod = getCurrentSelectedMethod(selectedMethodId, creditCardMethods)
  if (!currentSelectedMethod?.service_type) return null

  const resolvedModule = getActivePaymentModuleB2B(currentSelectedMethod.service_type, PaymentMethodType.CREDIT_CARD_ONCE)
  if (resolvedModule && getIsValidModule(resolvedModule, currentSelectedMethod)) {
    return resolvedModule as CreditCardPaymentModule
  }
  return null
}

export const validateCreditCard = (configuredPaymentModule: Nullable<AppliedPaymentModule>, cardValidation: CardValidation) => {
  const isTappay = configuredPaymentModule instanceof TappayCreditCardModule
  const isCheckoutPay = configuredPaymentModule instanceof CheckoutPayCreditCardModule
  if (!configuredPaymentModule || (!isTappay && !isCheckoutPay)) return false
  if (isTappay) {
    return cardValidation?.tappay?.canGetPrime
  }
  if (isCheckoutPay) {
    return cardValidation.checkoutpay?.isValid
  }
  return false
}
